import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/events/eventDetail.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getEventBySlug = (_0) => __async(void 0, [_0], function* ({ slug, lang }) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/event-detail/${slug}?lang=${locale}&visible_in=${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource}`,
      includeAuth: false
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getEventBySlugException"
    });
  }
});
var getPrivateEventBySlug = (_0) => __async(void 0, [_0], function* ({ slug, lang }) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/event-detail/${slug}?lang=${locale}&visible_in=${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource}&visibility=private`,
      includeAuth: false
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getPrivateEventBySlugException"
    });
  }
});

export {
  getEventBySlug,
  getPrivateEventBySlug
};
//# sourceMappingURL=chunk-27YX3545.mjs.map